import React from 'react';
import '../../styles/Tag.css';

const Tag = ({ children, color = 'gray' }) => {
    const className = `ui-tag tag-color-${color}`;
    return <span className={className}>{children}</span>;
};

export default Tag;